export default "__VITE_ASSET__cd64937e__"